import { ReactNode } from 'react';
import { APPLY_URL } from '@/pages/home/config';

export default function CtaLink({
  children,
  href = APPLY_URL,
  variant = 'primary',
  className = '',
}: {
  children: ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  className?: string;
}) {
  const base =
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 font-label font-semibold text-sm transition-all duration-300 hover:-translate-y-0.5';
  const styles =
    variant === 'primary'
      ? 'bg-primary-500 text-background-950 hover:bg-primary-400 shadow-[0_0_32px_rgba(116,216,189,0.22)]'
      : 'border border-primary-500/40 text-foreground-950 hover:border-primary-500 hover:bg-primary-500/10';

  return (
    <a href={href} className={`${base} ${styles} ${className}`}>
      {children}
    </a>
  );
}